import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { UserExport } from '@pixacare/domain';
import { EXPORTS_FEATURE_KEY } from './exports.selectors';

export const exportsActions = createActionGroup({
  source: EXPORTS_FEATURE_KEY,
  events: {
    'Get exports': emptyProps(),
    'Get exports success': props<{ dataExports: UserExport[] }>(),

    'Create export': emptyProps(),
    'Create export success': props<{ newExport: UserExport }>(),

    'Delete export': props<{ exportId: number }>(),
    'Delete export success': emptyProps(),
  },
});
